import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Col, Form, Grid, Image, Row, Select } from 'antd';
import SelectModalMobile from 'src/components/Article/SelectGroupWebMobile';
import TabMenu from 'src/components/Article/TabMenu';
import TabMenuCategoryNew from 'src/components/Article/TabMenuCategoryNew';
import ArticleDownloadBannerQRCode from 'src/components/Card/ArticleDownload';
import CardArticleHBSection1 from 'src/components/Card/ArticleHBSection1';
import CardArticleHBSection2New from 'src/components/Card/ArticleHBSection2New';
import CardArticleHBSection3New from 'src/components/Card/ArticleHBSection3New';
import { ButtonBorderGroup } from 'src/components/Forms/Button';
import g from 'src/constants/urls';
import { Articles, CategoryTopic, ICategoryByGroup, PromoProps } from 'src/interface';
import classes from './index.module.less';
type Props = {
  categoryTopic: ICategoryByGroup[];
  articles: Articles[];
  ads: PromoProps[];
  activeKey: string;
  onChange: (e: any) => void;
  activeKeyCategory: string;
  onChangeCategory: (e: any) => void;
  totalArticle?: number;
  isNoneSectionTitle?: boolean;
  showLoadmore?: boolean;
  showMainArticle?: boolean;
  color?: string;
  isSetHeight?: boolean;
  section1: any;
  section2: any;
  section3: any;
  category: any;
  group: any;
};
const ArticleContainerPraKehamilan = (props: Props) => {
  const dataCategory = props?.category;
  const dataGroups = props?.group;
  const {
    activeKey,
    onChange
  } = props;
  const [form] = Form.useForm();
  const [activeKeyCategory] = useState<string>('');
  const [descriptionCategory, setDescriptionCategory] = useState<any>('');
  const [dataGroup, setDataGroup] = useState<any>('');
  const router = useRouter();
  const phasePath = router.query.phase;
  const categoryTopics = [{
    name: 'Semua Topik',
    full_slug: 'semua-topik',
    slug: 'artikel'
  }, {
    name: 'Program Hamil',
    full_slug: 'pra-kehamilan',
    slug: 'pra-kehamilan'
  }, {
    name: 'Kehamilan',
    full_slug: 'kehamilan',
    slug: 'kehamilan'
  }, {
    name: 'Tumbuh Kembang',
    full_slug: 'pasca-kehamilan',
    slug: 'pasca-kehamilan'
  }];
  const {
    xs,
    md,
    lg,
    xl
  } = Grid.useBreakpoint();
  const mdS = md ? 5 : 50;
  const lgS = lg ? 6 : mdS;
  const keyTopic = xl ? 7 : lgS;
  const groupOptions = props.group;
  const [selectModal, setSelectModal] = useState(false);
  const [dataGroupSelectMobile, setDataGroupSelectMobile] = useState<any>('');
  const options = groupOptions.map((item: any) => ({
    value: item.code,
    label: item.name
  }));
  // const defaultValue = !options.length ? options[0].value : convertGroup(router.query.group);
  const defaultValue = options.find((item: any) => item.value === router.query.group);
  useEffect(() => {
    if (defaultValue) {
      form.setFieldsValue({
        group: defaultValue.label
      });
    }
  }, [defaultValue, form]);
  const handleChangeCategory = (selectedCategory: CategoryTopic) => {
    setDescriptionCategory(router.query.category === 'buat-mama' ? '' : selectedCategory?.description);
  };
  const handleChangeGroupM = async (item: any) => {
    setDataGroupSelectMobile(item);
    setSelectModal(false);
    // router.push(`/artikel/${phasePath}/${item?.value}/buat-mama`);
    window.location.href = `/artikel/${phasePath}/${item?.value}/buat-mama`;
    try {
      const queryUrl = router.query;
      const queryPhase = queryUrl.phase === 'pra-kehamilan' ? 'pre-pregnancy' : queryUrl.phase === 'pasca-kehamilan' ? 'post-pregnancy' : 'pregnancy';
      const uriCategory = `${g.API_ARTICLE_SLUG}/categories?type=${queryPhase}&filter_groups=${item.value}&order=asc&orderBy=sequence&is_show=true&page=1&per_page=50`;
      const optsCategory = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
      const cat = await fetch(uriCategory, optsCategory);
      const categoryArtikel: any = await cat.json().then(res => ({
        ...res,
        status: cat.status
      }));
      if (categoryArtikel?.status === 200) {
        const newData = categoryArtikel.data.records;
        // router.push(`/artikel/${phasePath}/${item?.value}/${newData[0].slug}`);
        form.setFieldsValue({
          group: item.label
        });
        // setDescriptionCategory(newData[0]?.description)
        setDescriptionCategory(router.query.category === 'buat-mama' ? '' : newData[0]?.description);
      }
    } catch {}
  };
  const openSelectModal = () => {
    setSelectModal(true);
  };
  const handleChangeGroup = async (item: any, option: any) => {
    setDataGroup(option);
    // router.push(`/artikel/${phasePath}/${item}/buat-mama`);
    window.location.href = `/artikel/${phasePath}/${item}/buat-mama`;
    form.setFieldsValue({
      group: item
    });
    try {
      const queryUrl = router.query;
      const queryPhase = queryUrl.phase === 'pra-kehamilan' ? 'pre-pregnancy' : queryUrl.phase === 'pasca-kehamilan' ? 'post-pregnancy' : 'pregnancy';
      const uriCategory = `${g.API_ARTICLE_SLUG}/categories?type=${queryPhase}&filter_groups=${item}&order=asc&orderBy=sequence&is_show=true`;
      const optsCategory = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
      const cat = await fetch(uriCategory, optsCategory);
      const categoryArtikel: any = await cat.json().then(res => ({
        ...res,
        status: cat.status
      }));
      if (categoryArtikel?.status === 200) {
        const newData = categoryArtikel.data.records;
        // router.push(`/artikel/${phasePath}/${option?.value}/${newData[0].slug}`);
        form.setFieldsValue({
          group: option.label
        });
        // setDescriptionCategory(newData[0]?.description)
        setDescriptionCategory(router.query.category === 'buat-mama' ? '' : newData[0]?.description);
      }
    } catch {}
  };
  useEffect(() => {
    if (!router.isReady) return;
    form.setFieldsValue({
      group: options[0]?.label
    });
    setDescriptionCategory(router.query.category === 'buat-mama' ? '' : dataCategory[0]?.description);
    setDataGroup(dataGroups[0]);
    const group = router.query.group;
    const selectedGroup = options.find((item: any) => item.value === group);
    setDataGroupSelectMobile(selectedGroup);
  }, [router.isReady]);
  useEffect(() => {
    const dtCat = dataCategory.filter((topic: any) => topic.slug === router.query.category);
    setDescriptionCategory(router.query.category === 'buat-mama' ? '' : dtCat[0]?.description);
    if (!router.query.category || router.query.category === 'undefined') {
      window.location.href = `/artikel/${phasePath}/${!router.query.group ? options[0]?.value : router.query.group}/buat-mama`;
    }
  }, []);
  return <div className={classes['page-body-wrap']}>
			<div className="container">
				<div className={classes.headContact}>
					<Row>
						<Col md={24} xs={24} lg={24}>
							<div className={classes.title}>
								<TabMenu activeKey={activeKey} onChange={onChange} categoryTopics={categoryTopics} keyTopic={keyTopic} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col md={4} xs={0} lg={4}>
							<div style={{
              paddingRight: '10px'
            }}>
								<Form form={form} validateTrigger="onBlur" layout="vertical" autoComplete="off" name="ant-artikel-custom">
									<Form.Item name="group">
										<Select className={classes.tabsGroup} onChange={handleChangeGroup} options={options} placeholder="Pilih Group"
                  // defaultActiveFirstOption={defaultValue.label}
                  // value={form.getFieldValue('group')}
                  />
									</Form.Item>
								</Form>
							</div>
						</Col>
						<Col md={0} xs={24} lg={0}>
							<div style={{
              marginRight: '10px'
            }}>
								<Form form={form} validateTrigger="onBlur" layout="vertical" autoComplete="off" name="ant-artikel-custom" onClick={e => e.stopPropagation()}>
									<Form.Item name="group">
										<ButtonBorderGroup text={dataGroupSelectMobile ? dataGroupSelectMobile.label : dataGroup.Label || dataGroup.name} className={classes.tabsGroup} onClick={openSelectModal} style={{
                    width: '98%',
                    border: '1px solid #4A4545',
                    color: '#4A4545',
                    textAlign: 'left',
                    marginLeft: '10px'
                  }} />
									</Form.Item>
								</Form>
								<SelectModalMobile visibleModal={selectModal} setVisibleModal={setSelectModal} handleChangeGroupMobile={handleChangeGroupM} data={options} />
							</div>
						</Col>
						<Col md={20} xs={24} lg={20}>
							<div className={classes.tabs} style={{
              marginLeft: '10px'
            }}>
								<TabMenuCategoryNew activeKeyCategory={activeKeyCategory} handleChangeCategory={handleChangeCategory} categoryTopics={dataCategory} keyTopic={keyTopic} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							{props.section1.length === 0 ? '' : <h1 className={classes.descriptionCategory} style={{
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              lineHeight: 1.5,
              maxHeight: '2 em'
            }}>
									{descriptionCategory}
								</h1>}
						</Col>
					</Row>

					{props.section1.length === 0 ? <div style={{
          textAlign: 'center'
        }}>
								<Image src="/images/artikel/ctaKosong.webp" preview={false} alt='Author-artikel-null' width={250} height={219} />
								<div>
									<p className={classes.paragraph}>
										Belum ada apa-apa di sini, Ma. Stay tuned, yaa!
									</p>
								</div>
							</div> : <Row>
								<Col md={14} sm={14} xs={24} lg={14} xl={14}>
									<CardArticleHBSection1 data={props.section1} />
								</Col>
								<Col md={10} sm={10} xs={24} lg={10} xl={10} style={{
            marginTop: xs ? '-15px' : '0px'
          }}>
									<CardArticleHBSection2New data={props.section1} />
								</Col>
							</Row>}
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<CardArticleHBSection3New data={props.section3} />
						</Col>
					</Row>
				</div>
				{/* <div className={classes.download}>
     <ArticleDownloadContainer />
     </div> */}
				<ArticleDownloadBannerQRCode />
			</div>
		</div>;
};
export default ArticleContainerPraKehamilan;